<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import Fa from 'svelte-fa'
    import type { BlockDefinition } from '../types/block-definition'

    export let definition: BlockDefinition

    const dispatch = createEventDispatcher()

    function onDragStart(event: DragEvent) {
        event.dataTransfer?.setData('application/json', JSON.stringify({ source: 'palette', blockType: definition.type }))
        event.dataTransfer.effectAllowed = 'copy'
    }
</script>

<button
    type="button"
    class="palette-item"
    draggable="true"
    on:dragstart={onDragStart}
    on:click={() => dispatch('add', { blockType: definition.type })}
    title={definition.description}
>
    <span class="palette-icon">
        <Fa icon={definition.icon} />
    </span>
    <span class="palette-label">{definition.label}</span>
</button>

<style>
    .palette-item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 10px 12px;
        background: #252525;
        border: 1px solid #333;

        border-radius: 10px;
        text-align: left;
        cursor: grab;
        transition:
            border-color 0.15s ease,
            box-shadow 0.15s ease,
            transform 0.1s ease;
    }
    .palette-item:hover {
        border-color: var(--bs-primary, #328866);
        box-shadow: 0 2px 8px rgba(50, 136, 102, 0.28);
        transform: translateY(-1px);
    }
    .palette-item:active {
        cursor: grabbing;
    }
    .palette-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 8px;
        background: #2a2a2a;
        color: #ccc;
        flex-shrink: 0;
    }
    .palette-label {
        font-size: 0.88rem;
        color: #ccc;
    }

    /* ───── tema claro ───── */
    :global(.theme_light) .palette-item {
        background: #fff;
        border-color: #e9ecef;
    }
    :global(.theme_light) .palette-item:hover {
        border-color: var(--bs-primary, #328866);
        box-shadow: 0 2px 8px rgba(50, 136, 102, 0.16);
    }
    :global(.theme_light) .palette-icon {
        background: #f1f3f5;
        color: #495057;
    }
    :global(.theme_light) .palette-label {
        color: #343a40;
    }
</style>
